// extracted by mini-css-extract-plugin
export var bodySections = "_68-8";
export var gray = "_68-7";
export var green = "_68-4";
export var iconContainer = "_68-9";
export var iconWidgetContainer = "_68-1";
export var phoneIcon = "_68-2";
export var red = "_68-5";
export var statusDot = "_68-3";
export var widgetContainer = "_68-0";
export var yellow = "_68-6";